module.exports = __webpack_public_path__ + "static/media/Sigurd.d67835f9.png";